<template>
  <div class="flex h-full flex-1 overflow-hidden bg-white">
    <div
      class="flex w-full max-w-full flex-col justify-center overflow-hidden bg-white py-0 lg:max-w-xl"
    >
      <div
        class="mx-auto w-full max-w-lg overflow-auto px-4 pt-12 sm:px-6 lg:max-w-xl lg:px-20 xl:px-24"
      >
        <div id="frontpage-logo">
          <ImageComponent
            alt="Go to frontpage logo"
            :asset-info="{ name: brand, type: 'logo', extension: 'png' }"
            class="mb-3 h-10 w-auto"
          />
        </div>
        <div :class="idLogon.pageSpinner === true ? 'overflow-hidden' : ''">
          <slot></slot>
        </div>
      </div>
    </div>
    <div class="relative hidden w-0 flex-1 lg:block">
      <ImageComponent
        :source="appStore.siteContent.settings?.loginBackgroundUrl"
        class="absolute inset-0 h-full w-full object-cover"
        alt="Login page image"
      />
    </div>
  </div>
</template>
<script setup lang="ts">
import { useIdLogonStore } from '@/stores/portal-stores/component-stores/IdLogon'
import { useAppStore } from '@/stores/portal-stores/general-stores/app'

const appStore = useAppStore()
const idLogon = useIdLogonStore()
const brand = appStore.getBrand()
</script>
